import { useFeatures, FeatureFlagProvider } from './FeatureGateContext';
import FeatureUnavailable from './FeatureUnavailable';

/**
 * FeatureGate — renders `children` only when the named feature is enabled
 * for the logged-in user's role at their institution (fetched from GET /features/me).
 * Fails open (renders children) while features are loading or on transient errors;
 * the backend remains the authoritative enforcer.
 */
export function FeatureGate({ feature, children, fallback = null }) {
  const { isEnabled } = useFeatures();
  const ok = isEnabled(feature);
  return ok ? (children ?? <></>) : fallback;
}

/**
 * SubFeatureGate — same shape, but checks the per-role sub-feature switch
 * (v2 role matrix from /features/me subs). A feature-level OFF always disables
 * its subs; an uncatalogued sub fails open.
 */
export function SubFeatureGate({ feature, sub, children, fallback = null }) {
  const { isSubEnabled } = useFeatures();
  const ok = isSubEnabled(feature, sub);
  return ok ? (children ?? <></>) : fallback;
}

// Re-export so everything that imports from './FeatureGate' (FeatureGate,
// SubFeatureGate, useFeatures, FeatureFlagProvider) resolves from one barrel.
export { FeatureFlagProvider, useFeatures };
